import { canv } from "@/canv/global";
import { PresentationWidget } from "@/elements/Presentation/Presentation";
import { Group } from "@/group";
import { toolBase } from "@/tools/toolBase";
import { selectionManager } from "../cursorTool";

export class PresentationTool extends toolBase {
    getToolView() {
        return `
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="m19.6154 4.99996h-6.9231v-1.33331c0-.1768-.0729-.34637-.2028-.47139-.1298-.12502-.3059-.19526-.4895-.19526s-.3597.07024-.4895.19526c-.1299.12502-.2028.29459-.2028.47139v1.33331h-6.92308c-.36723 0-.71941.14048-.97908.39052-.25966.25004-.40554.58918-.40554.94279v9.99983c0 .3536.14588.6927.40554.9428.25967.25.61185.3905.97908.3905h3.40615l-1.8701 2.25c-.11475.1381-.16783.3145-.14754.4903s.11227.3366.25572.4471c.14344.1105.3266.1617.50918.1421.18258-.0195.34962-.1081.46437-.2462l2.56068-3.0833h4.87382l2.5607 3.0833c.0568.0684.1271.1253.2068.1676.0796.0422.1672.0689.2576.0786s.1819.0021.2692-.0223c.0874-.0243.1689-.065.24-.1198.071-.0547.1301-.1223.174-.1991.0439-.0767.0716-.161.0817-.248.01-.0871.0022-.1752-.0232-.2593-.0253-.0841-.0676-.1626-.1244-.231l-1.8701-2.25h3.4062c.3672 0 .7194-.1405.9791-.3905.2596-.2501.4055-.5892.4055-.9428v-9.99983c0-.35361-.1459-.69275-.4055-.94279-.2597-.25004-.6119-.39052-.9791-.39052zm0 11.33314h-15.23078v-9.99983h15.23078z"
                fill="currentColor"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Презентация";
    }

    unselect() {
        super.unselect();

        this.ghost = null;
        this.clickMove = 0;
    }

    getWidgetWrapper(isGhost = false) {
        const newPresentation = new PresentationWidget(0, 0);
        newPresentation.name = "Новая презентация";
        newPresentation.accountName = canv.getInitDataProp("userName");
        newPresentation.creatorToken = canv.getInitDataProp("userToken");
        newPresentation.createdAt = new Date().toISOString();

        const newGroup = new Group(true, isGhost);

        newPresentation.setParent(newGroup);

        return newGroup;
    }

    TryAction(type) {
        if (type === "mouseup") {
            if (this.ghost == null) return;

            canv.canvasController.addGroup(this.ghost);
            canv.eventManager.openRecord();
            canv.eventManager.createBuildEvent("create", this.ghost);
            canv.eventManager.closeRecord();

            selectionManager.setSelected([this.ghost]);
        }
        if (type === "mousemove") {
            if (this.ghost == null) {
                this.ghost = this.getWidgetWrapper(true);
            }
            const pt = canv.actionManager.getActionPoint();

            const translateX = pt.x - this.ghost.startX;
            const translateY = pt.y - this.ghost.startY;
            this.ghost.translateGroup(translateX, translateY);
        }

        canv.redraw();
    }

    draw() {
        if (this.ghost == null) return;

        canv.ctx.globalAlpha = 0.2;
        this.ghost.draw();
        this.ghost.drawOver();
        canv.ctx.globalAlpha = 1;
    }

    name = "presentationTool";
    ghost: Group | null = null;

    clickMove = 0;
}
